import * as angular from 'angular';
import nvSdcModule from '../../../../../nv.sdcModule.module';
import { RegentsExamsSupportsTableCtrl } from './regents-exams-supports-table.controller';

export const RegentsExamsSupportsTableComponent = {
  controller: RegentsExamsSupportsTableCtrl,
  template: require('./regents-exams-supports-table.html'),
  bindings: {
    currentSchool: '<',
    studentSupports: '<',
  },
};

angular.module(nvSdcModule).component('regentsExamsSupportsTable', RegentsExamsSupportsTableComponent);
